export class AmlineAddress {
    line1: string = '';
    line2: string = '';  
    line3: string = '';  
    county: string = '';  
    postcode: string = '';  
    
}
